import {
	type FrontendPlacementMessage,
	type FrontendStage,
} from '@post-office/message-maker-browser/types';

import { noValidation } from '@post-office/message-maker-browser/message-helpers';

import {
	PlacementFrontend,
	type PlacementRenderProps,
} from '@post-office/browser--rovo-agents/agent-studio-page-pre-content';

import { OnboardingBanner } from '../../../components/onboarding-banner';

import type { MessageTemplateContext } from '../../../index';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

type RenderProps = MessageTemplateContext & PlacementRenderProps & { messageInstanceId: string };

// This is the Message Frontend. In this Placement we have render.Component which takes a React Component which will render your message in the Placement.
export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: FrontendStage<PlacementRenderProps>;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<RenderProps>(),

		Component: ({ onDismiss }: RenderProps) => {
			return <OnboardingBanner onDismiss={onDismiss} />;
		},
	},
});
